import types from './action-types';

const baseState = {
    hasError: false,
    error: null,
    fetching: false,
};

const defaultState = {
    ...baseState,
    offers: {},
    selectedTermsByAmount: {},
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.OFFERS_GET_PENDING:
        return Object.assign({}, state, baseState, {
            fetching: true,
        });

    case types.OFFERS_GET_FAILED:
        return Object.assign({}, state, baseState, {
            hasError: true,
            error: action.error,
        });

    case types.OFFERS_GET_SUCCESS:
        return Object.assign({}, state, baseState, {
            ...action.res.data,
            selectedTermsByAmount: {}, // Reset selected terms when new offers load
        });

    case types.OFFERS_TERM_SELECT:
        return Object.assign({}, state, {
            selectedTermsByAmount: {
                ...state.selectedTermsByAmount,
                [action.amount]: action.term,
            },
        });

    case types.OFFERS_TERM_RESET:
        const newSelectedTermsByAmount = { ...state.selectedTermsByAmount };
        delete newSelectedTermsByAmount[action.amount];
        return Object.assign({}, state, {
            selectedTermsByAmount: newSelectedTermsByAmount,
        });

    default:
        return Object.assign({}, state);
    }
};

export default reducer;
